import { Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { ProductsService } from 'src/app/shared/services/products/products.service';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';

import { OpEnum } from '../../../shared/enums/op.enum';
import { IProductsModel, ProductsDetailModel, VtuModel } from '../../../shared/models/products.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { BioCatchService } from '../../../shared/services/external/biocatch/biocatch.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { TaggingService } from '../../../shared/services/tagging/tagging.service';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { ConfigurationService } from 'src/app/shared/services/configuration/configuration.service';

/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-selected-product-detail',
  templateUrl: './selected-product-detail.component.html',
  styleUrls: ['./selected-product-detail.component.scss'],
})
/**
 * Clase del componente de los detalles del producto seleccionado
 *
 * *Selected product details component class*
 *
 * @implements {OnInit}
 */
export class SelectedProductDetailComponent implements OnInit {

  /**
   * Define el estado por defecto para mostrar el modal
   *
   * *Sets modal default state to show modal*
   *
   * @access public
   * @type {boolean}
   */
  showModal = false;

  /**
   * Define el título para las pestañas de los componentes
   *
   * *Sets modal default state to show modal*
   *
   * @access public
   * @type {string[]}
   */
  listTabs: string[] = [];

  /**
   * Define la variable currentTab como number donde se registra la pestaña actual del componente
   *
   * *Sets currentTab variable as number where the number of the current tab is saved*
   *
   * @access public
   * @type {number}
   */
  currentTab: number;

  /**
   * Define la variable benefitList como una arreglo donde se registrará la lista de beneficios del producto
   *
   * *Sets benefitList variable as empty array where product benefits will be registered*
   *
   * @access public
   * @type {any}
   */
  benefitList: any = [];

  /**
   * Define la variable principalCharacteristics como una arreglo donde se registrará las principales caracteristicas del producto
   *
   * *Sets principalCharacteristics variable as empty array where product main characteristics list will be registered*
   *
   * @access public
   * @type {any}
   */
  principalCharacteristics: any = [];

  /**
   * Define la variable transactionalBenefits como una arreglo donde se registrará los beneficios de las transacciones del producto
   *
   * *Sets transactionalBenefits variable as empty array where product transational benefits will be registered*
   *
   * @access public
   * @type {any}
   */
  transactionalBenefits: any = [];

  /**
   * Define la variable requirements como una arreglo donde se registrará la lista de requisitos del producto
   *
   * *Sets requirements variable as empty array where product requiremetns will be registered*
   *
   * @access public
   * @type {any}
   */
  requirements: any = [];

  /**
   * Define le modelo de vtu
   *
   * *Sets vtu model*
   *
   * @access public
   * @type {string[]}
   */
  vtu: VtuModel;

  /**
   * Define la variable ip como una Array
   *
   * *Defines ip variable as array*
   *
   * @access public
   * @type {Array}
   */
  ip = Array as any;

  /**
   * Define la variable productsDetail como modelo de ProductsDetailModel, aquí están los detalles de los productos
   *
   * *Sets productsDetail variable as ProductDetailModel, there are products details*
   *
   * @access public
   * @type {string[]}
   */
  productsDetail: ProductsDetailModel;

  /**
   * Define la variable productSelected como interfaz de IProductModel, selección del producto
   *
   * *Defines productSelected variable as IProductModel interfaace, product selected *
   *
   * @access public
   * @type {IProductsModel}
   */
  productSelected: IProductsModel;

  /**
   * Define el título por defecto del header
   *
   * *Sets default header title*
   *
   * @access public
   * @type {string}
   */
  headerTitle = 'headerTitle';

  tableHeaderFields: string[];

  consultation_request = 'ConsultationRequest';
  channelId;
  channel: string;
  imageLink1: any;
  imageLink2: any;
  imageLink3: any;
  imageLink4: any;
  allies: any;

  /**
   * Summary      Constructor of the component.
   *
   * @param {CopyService}        copyService        Injectable copyService service.
   * @param {NavigationService}  navigationService  Injectable navigationService service.
   * @param {AbreCuentasService} abreCuentasService Injectable abreCuentasService service.
   * @param {ParametersService}  parametersService  Injectable parametersService service.
   * @param {BioCatchService}    bioCatchService    Injectable bioCatchService service.
   * @param {DomSanitizer}       _sanitizer         Injectable _sanitizer service.
   * @param {ProductsService}    productsService    Injectable productsService service.
   */
  constructor(
    public copyService: CopyService,
    public helper: HelpersService,
    private navigationService: NavigationService,
    public abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private bioCatchService: BioCatchService,
    private _sanitizer: DomSanitizer,
    private productsService: ProductsService,
    private headerService: HeaderService,
    private taggingService: TaggingService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private bitacoraService: BitacoraService,
    private requestService: RequestService,
    private configurationService: ConfigurationService,

  ) {
    this.headerService.show(false, false, true);
  }

  /**
   * Carga la información para el formulario y las pestañas
   *
   * *Summary charge data for form and tabs*
   */
  // ngOnInit() {
  //   const isEvidente = this.bioCatchService.isEvidenteCase();
  //   // const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
  //   console.warn('product',this.abreCuentasService.getproductSelected());

  //   // this.bioCatchService.changeContext(StepBiocatchEnum.solicitud, product, false, isEvidente);
  //   this.listTabs = [
  //     this.copyService.copies.product_detail_tab1,
  //     this.copyService.copies.product_detail_tab2,
  //     this.copyService.copies.product_detail_tab3,
  //     this.copyService.copies.product_detail_tab4,
  //   ];
  //   this.currentTab = 1;
  //   this.productSelected = this.abreCuentasService.getproductSelected();
  //   console.log('productSelected',this.productSelected);

  //   this.productsDetail = this.productSelected.detail_product;
  //   this.vtu = this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_DETAIL_VTU)[this.productSelected.flow];
  //   if (this.channelCommunicatorService.getChannelId() === '163') {
  //     // tslint:disable-next-line:no-shadowed-variable
  //     const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
  //     console.log('product',product);

  //     this.loadCopies();
  //     setTimeout(() => {
  //       this.bioCatchService.changeContext(StepBiocatchEnum.solicitud, product, false, isEvidente);
  //     }, 1000);
  //   } else {
  //     // tslint:disable-next-line:no-shadowed-variable
  //     const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
  //     this.bioCatchService.changeContext(StepBiocatchEnum.solicitud, product, false, isEvidente);
  //     this.productSelected = this.abreCuentasService.getproductSelected();
  //     this.productsDetail = this.productSelected.detail_product;
  //     this.vtu = this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_DETAIL_VTU)[this.productSelected.flow];

  //     if (this.productsDetail.costs) {
  //       this.tableHeaderFields = this.productsDetail.costs.table.title.map(e => e.key);
  //     }
  //   }
  //   if (this.productsDetail.costs) {
  //     this.tableHeaderFields = this.productsDetail.costs.table.title.map(e => e.key);
  //   }
  // }
  ngOnInit() {
    if (this.parametersService.getParameter('warningDisplay') &&
    (this.channelCommunicatorService.getChannelId() === '141' ||
    this.channelCommunicatorService.getChannelId() === '163' ||
    this.channelCommunicatorService.getChannelId() === '131' ||
    this.channelCommunicatorService.getChannelId() === '160')) {
      this.navigationService.navigateToGeneralInformation('999');
    }
    const isEvidente = this.bioCatchService.isEvidenteCase();
    // const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    // this.bioCatchService.changeContext(StepBiocatchEnum.solicitud, product, false, isEvidente);
    this.listTabs = [
      this.copyService.copies.product_detail_tab1,
      this.copyService.copies.product_detail_tab2,
      this.copyService.copies.product_detail_tab3,
      this.copyService.copies.product_detail_tab4,
    ];
    this.currentTab = 1;
    // tslint:disable-next-line:early-exit
    if (this.channelCommunicatorService.getChannelId() === '163') {
      // const allyName = this.abreCuentasService.getproductSelected().es;
      const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
      this.loadCopies();
      setTimeout(() => {
        // this.bioCatchService.changeContext(StepBiocatchEnum.solicitud, product, false, isEvidente);
      }, 1000);
    } else {
      // tslint:disable-next-line:no-shadowed-variable
      const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;

      // this.bioCatchService.changeContext(StepBiocatchEnum.solicitud, product, false, isEvidente);
      this.productSelected = this.abreCuentasService.getproductSelected();
      this.productsDetail = this.productSelected.detail_product;
      this.vtu = this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_DETAIL_VTU)[this.productSelected.flow];
      if (this.productsDetail.costs) {
        this.tableHeaderFields = this.productsDetail.costs.table.title.map(e => e.key);
      }
    }
  }
  async loadCopies() {
    this.channel = this.channelCommunicatorService.getChannelId();
    await this.requestService.documentsAllies()
      .then(res => this.allies = res.Ally)
      .catch(err => console.log(err));
    const ally = this.allies.filter(item => item.code_Ally === this.abreCuentasService.getAllyCode());
    this.productSelected = ally[0];
    this.productsDetail = this.productSelected.detail_product;
    this.imageLink1 = ally[0].banner[0].value;
    this.imageLink2 = ally[0].banner[1].value;
    this.imageLink3 = ally[0].banner[2].value;
    this.imageLink4 = ally[0].banner[3].value;
    this.vtu = this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_DETAIL_VTU)[this.productSelected.flow];
    if (this.productsDetail.costs) {
      this.tableHeaderFields = this.productsDetail.costs.table.title.map(e => e.key);
    }
  }

  /**
   * Siguiente paso
   *
   * *Summary Next Step*
   */
  next() {
    if (this.abreCuentasService.getAllyCode()) {
      this.configurationService.getRatesByAllies(this.abreCuentasService.getAllyCode())
        .then(response => {
          console.log(response.data);
          this.abreCuentasService.setRateAlly(response.data);
          console.log(this.abreCuentasService.getRateAlly().rates);
          // console.warn('---->TASAS', this.configurationService.getRatesByAllies());
        }).catch(err => console.log('errConfig', err));
    }
    this.productsService.getAgreementsOffers().then(response => {
      this.navigationService.nextStep(response);
    }, () => {
      this.navigationService.navigateToGeneralInformation('500');
    }).catch(() => this.navigationService.navigateToGeneralInformation('500'));

  }

  /**
   * Pestaña seleccionada
   *
   * *Summary Selected Tab*
   *
   * @param event
   */
  onClickTab(event) {
    this.currentTab = event.current;
    this.pageTagEvent(event.selected);
  }

  /**
   * Muestra el modal de VTU
   *
   * *Summary Show Modal VTU*
   */
  showModalVTU() {
    console.log('showModalVTU', this.productSelected.product_type, BUSINESS_CONST.PRODUCT_TYPE_TC);
    // in analist
    this.openLink(this.productSelected.detail_product.characteristics.vtu_text.link);
    // if (this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
    //  const endpoint = this.productSelected.detail_product.characteristics.vtu_text.link;
    //  this.openLink(endpoint);
    // } else {
    //  document.body.classList.add('no-scroll');
    //  // Se agregó el tag pv123, aunque hay que validar el tag para tarjeta de crédito
    //  this.navigationService.pageLoadTag(false, ['pv224', 'pv120', 'pv80', 'pv123']);
    //  this.showModal = true;
    // }
  }

  /**
   * Cierra el modal de VTU y envia el tag de las carácteristicas
   *
   * *Summary close vtu modal and send the tag of characteristics*
   */
  closeModalVTU() {
    document.body.classList.remove('no-scroll');
    this.showModal = false;
  }

  /**
   * Valida la seguridad de la aplicación a nivel de webview por medio del servicio BioCatch
   *
   * *Check app security at webview level by BioCatch service*
   */
  checkBioCatch() {
    if (this.productSelected.name === 'ConsultationRequest') {
      this.taggEvent('10', this.copyService.copies.controls_return_button_soli.action2);
    } else {
      this.taggEvent('10', this.copyService.copies.controls_return_button.action2);
    }
    this.abreCuentasService.showGenericLoading();
    if (this.productSelected.name !== 'ConsultationRequest') {
      this.bioCatchService.checkCountry(false).then(response => {
        this.abreCuentasService.hideGenericLoading();
        if (response.data.response) {
          this.next();
        } else {
          this.navigationService.navigateToGeneralInformation('dsbException');
        }
      }, _ => {
        this.abreCuentasService.hideGenericLoading();
        this.navigationService.navigateToGeneralInformation('500');
      }).catch(() => {
        this.abreCuentasService.hideGenericLoading();
        this.navigationService.navigateToGeneralInformation('500');
      });
    } else {
      this.abreCuentasService.hideGenericLoading();
      this.next();
    }
  }

  /**
   * Sanitiza el texto del detalle del producto en el html
   *
   * *Sanitize text when html from product detail*
   *
   * @param {string} text
   * @returns {string} with sanitized text
   * @memberof ProductDetailComponent
   */
  sanitize(text: string): string | null {
    return this._sanitizer.sanitize(SecurityContext.HTML, text);
  }

  /**
   * Servicio para enviar datos a Google analytics
   *
   * *Send data to Google Analytics*
   *
   * @param {string} eventLabel
   */
  pageTagEvent(eventLabel: string) {
    const event: TagEvent = {
      category: {
        module: EVENT.customCategory.module.body,
        type: EVENT.customCategory.type.link,
        position: EVENT.customCategory.position.top,
      },
      action: EVENT.customAction.click,
      label: this.navigationService.camelize(eventLabel),
    };
    this.taggingService.pageTagEvent(event);
  }

  /**
   * Opens link to itau page
   *
   * @memberof SuccessPcoComponent
   */
  openLink(link: string) {
    this.channelCommunicatorService.getImpl().openExternalBrowser(link, 5, true);
  }

  /**
   * Detect previus click
   */
  previous() {
    this.taggEvent('10', this.copyService.copies.controls_return_button.action1);
  }

  /**
   * Send tagg event on buttons continue and return
   * @param tag_number
   * @param label
   * @returns
   */
  taggEvent(tag_number: string, label?: string) {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    if (tagPageName !== 'pv458') { return; }
    try {
      const changes = this.taggingService.createTagChanges(tagPageName, tag_number);
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.body,
          type: EVENT.customCategory.type.button,
          position: EVENT.customCategory.position.center,
        },
        action: EVENT.customAction.click,
        label: label ? label : EVENT[`${tagPageName}E${tag_number}customLabel`],
      };
      this.taggingService.pageTagEvent(event, changes);
    } catch (error) {
      console.log(`Error en ${error}`);
    }
  }
}
